module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.groupNum || (_vm.groupNum && _vm.data.length)) ? _c('droppable', {
    staticClass: "group",
    class: {
      collapsable: _vm.collapsable, collapsed: _vm.collapsed
    },
    style: ({
      width: _vm.collapsable ? (_vm.totalVotes + "%") : ''
    }),
    on: {
      "drag-drop": function($event) {
        _vm.$emit('drag-drop', $event)
      }
    }
  }, [_c('header', {
    style: ({
      backgroundColor: _vm.getGroupColor(_vm.groupNum)
    })
  }, [_c('div', {
    staticClass: "name"
  }, [(!_vm.groupNum) ? _c('div', [_vm._v("Ungrouped")]) : _c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.groupName,
      "placeholder": ("Group " + _vm.groupNum)
    },
    on: {
      "input": function($event) {
        _vm.handleNameChange($event)
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button total",
    attrs: {
      "disabled": !_vm.collapsable
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleCollapse($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.totalVotes) + "\n      "), (_vm.tooltip) ? _c('md-tooltip', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }]
  }, _vm._l((_vm.sortedData), function(datum) {
    return _c('datum', {
      key: datum.key,
      attrs: {
        "datum": datum
      }
    })
  })), _vm._v(" "), _vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f02e85b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Group.vue
// module id = 260
// module chunks = 1